import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Text from '../text/text';
import InfoIcon from '../infoIcon/infoIcon';
var renderSuffixItems = function renderSuffixItems(suffix) {
  return suffix ? suffix.map(function (suffixItem, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "control-header-suffix-".concat(i)
    }, suffixItem);
  }) : null;
};
var renderInfoIcon = function renderInfoIcon(infoIconProps, shouldShowInfoIcon, showInfoIcon, hideInfoIcon) {
  return infoIconProps ? /*#__PURE__*/React.createElement(InfoIcon, _extends({}, infoIconProps, {
    tooltipClassName: shouldShowInfoIcon ? 'show-info-icon' : '',
    onTooltipOpen: showInfoIcon,
    onTooltipClosed: hideInfoIcon
  })) : null;
};
var renderLabel = function renderLabel(labelProps) {
  return /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    skin: "standard",
    dataHook: labelProps.dataHook,
    disabled: labelProps.disabled,
    shouldTranslate: false
  }, labelProps.text);
};
var ControlHeader = function ControlHeader(_ref) {
  var dataHook = _ref.dataHook,
    labelProps = _ref.labelProps,
    suffix = _ref.suffix,
    infoIconProps = _ref.infoIconProps,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldShowInfoIcon = _useState2[0],
    setShouldShowInfoIcon = _useState2[1];
  var hideInfoIcon = function hideInfoIcon() {
    return setShouldShowInfoIcon(false);
  };
  var showInfoIcon = function showInfoIcon() {
    return setShouldShowInfoIcon(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: "control-header-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "control-header-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, renderLabel(labelProps)), /*#__PURE__*/React.createElement("div", {
    className: "suffix"
  }, renderSuffixItems(suffix), renderInfoIcon(infoIconProps, shouldShowInfoIcon, showInfoIcon, hideInfoIcon))), children);
};
ControlHeader.displayName = 'ControlHeader';
ControlHeader.getDisplayName = function () {
  return 'ControlHeader';
};
ControlHeader.defaultProps = {
  dataHook: undefined,
  suffix: undefined,
  infoIconProps: undefined,
  labelProps: {
    text: '',
    disabled: false,
    dataHook: ''
  }
};
ControlHeader.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Control header label props */
  labelProps: PropTypes.shape({
    text: PropTypes.string,
    disabled: PropTypes.bool,
    dataHook: PropTypes.string
  }),
  /** A list of react nodes as suffix*/
  suffix: PropTypes.arrayOf(PropTypes.node),
  /** infoIconProps , infoIcon shows on hover*/
  infoIconProps: PropTypes.object
};
export default ControlHeader;